import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { DetailedTeam, fetchTeamDetails } from '../queries/getTeamData';

export function useGetTeamDetails(
  teamId: string | undefined,
): UseQueryResult<DetailedTeam | null> {
  return useQuery({
    queryKey: ['teamDetails', teamId],
    queryFn: () => (teamId ? fetchTeamDetails(teamId) : null),
    enabled: !!teamId,
  });
}
